
import { metadata, FEATURE_DIRECTOR_ID, FEATURE_HIDE_IN_PRODUCTION } from "../metadata"

import moment from "moment"

export const TREASURES = "treasures"
export const ACQUISITIONS = "acquisitions"
export const LISTS = "lists"
export const LIFE_LISTS = "life-lists"
export const COIL = "coil"
export const SELECTION = "selection"
export const SELECTIONS = "selections"
export const TYPE = "type"
export const GENRE = "genre"
export const MOVEMENT = "movement"
export const CINECLUB = "cineclub"
export const LIST_TARGETS = [
	{ key: TREASURES, name: "Trésors cachés" },
	{ key: LISTS, name: "Les listes de" },
	{ key: LIFE_LISTS, name: "Liste de leur vie" },
	{ key: SELECTION, name: "Sélection du Mois"},
	{ key: SELECTIONS, name: "Focus sur" },
	{ key: TYPE, name: "Types" },
	{ key: GENRE, name: "Genres" },
	{ key: COIL, name: "Homepage - slider bobinez" },
	{ key: MOVEMENT, name: "Courants cinématographiques" },
	{ key: ACQUISITIONS, name: "Nouvelles acquisitions" },
]

export const inListsOf = (product, director, ids) => {
	let listsOf = product.extension.categories.items.filter(c => {
		return (
			(c.parent && (c.parent.id == ids[LISTS] || c.parent.id == ids[LIFE_LISTS]))
		 	|| (c.parent && c.parent.parent && (c.parent.parent.id == ids[LISTS] || c.parent.parent.id == ids[LIFE_LISTS]))
		) && (!director || director.id !== metadata(c, FEATURE_DIRECTOR_ID))
	})
	listsOf = listsOf.map(l => {
		if (l.parent && l.parent.parent && (l.parent.parent.id == ids[LISTS] || l.parent.parent.id == ids[LIFE_LISTS])) {
			return l.parent
		} else return l
	})
	return listsOf
}
export const inLifeList = (category, ids) => {
	return (category.parent && category.parent.id == ids[LIFE_LISTS])
		|| (category.parent.parent && category.parent.parent.id == ids[LIFE_LISTS])
}

export const inListOf = (product, ids) => {
	const lists = inListsOf(product, ids)
	if (lists.length > 0) {
		const index = Math.floor(Math.random() * Math.floor(lists.length))
		return lists[index]
	} else {
		return null
	}
}
export const isInMonthSelection = (product, ids) => {
	const selections = product.extension.categories.items.filter(c => c.parent && c.parent.parent && c.parent.parent.id == ids[SELECTION])
	let result = false
	if (selections.length > 0) {
		const previousSelection = selections.find(s => s.name.split("_")[0] == moment().subtract(1, "month").format("YYYY-MM"))
		const currentSelection = selections.find(s => s.name.split("_")[0] == moment().format("YYYY-MM"))
		const nextSelection = selections.find(s => s.name.split("_")[0] == moment().add(1, "month").format("YYYY-MM"))
		let selection = null
		result = isCurrentMonthSelection(currentSelection) || isCurrentMonthSelection(previousSelection) || isCurrentMonthSelection(nextSelection)
	}
	return result
}

const isCurrentMonthSelection = (selection) => {
	let result = false
	if (selection) {
		const now = moment()
		//const dateFrom = moment.parseZone(metadata(selection, FEATURE_DATE_FROM), 'DD/MM/YYYY')
		const dateFrom = moment.parseZone(`O8/${selection.name.split("_")[0]}`, "DD/MM/YYYY")
		//const dateTo = moment.parseZone(metadata(selection, FEATURE_DATE_TO), 'DD/MM/YYYY').endOf('day')
		const dateTo = moment.parseZone(`08/${selection.name.split("_")[0]}`, "DD/MM/YYYY")
		if (dateFrom < now && dateTo >= now) {
			result = true
		}
	}
	return result
}

export const inTreasures = (product, ids) => {
	const treasures = product.extension.categories.items.filter(c => c.parent && c.parent.id == ids[TREASURES])
	return treasures.length ? treasures : false
}

export const inCollections = (product, ids) => {
	const collections = product.extension.categories.items.filter(c => c.parent && c.parent.parent && c.parent.parent.id == ids[TREASURES])
	return collections.length ? collections : false
}

export const inMovements = (product, ids) => {
	const movements = product.extension.categories.items.filter(c => c.parent && c.parent.id == ids[MOVEMENT])
	return movements.length ? movements : false
}

export const hideInProduction = (category, env) => {
	if (!category || !category.metadata) {
		return false
	}

	if (env !== "production") {
		return false
	}

	return metadata(category, FEATURE_HIDE_IN_PRODUCTION) === "oui"
}
